<template>
	<validation-provider
		:rules="rules"
		:name="name"
		:vid="vid"
		v-bind="$attrs"
		v-slot="{ errors, valid, invalid, validated }"
	>
		<b-form-group>
			<slot name="label">
				<label v-if="label" :class="labelClasses">
					{{ label }}
				</label>
			</slot>
			<div
				:class="[
					{ 'input-group': hasIcon },
					{ focused: focused },
					{ 'input-group-alternative': alternative },
					{ 'has-label': label || $slots.label },
					inputGroupClasses,
				]"
			>
				<div
					v-if="prependIcon || $slots.prepend"
					class="input-group-prepend"
				>
					<span class="input-group-text">
						<slot name="prepend">
							<i :class="prependIcon"></i>
						</slot>
					</span>
				</div>
				<slot v-bind="slotData">
					<select
						:value="value"
						v-on="listeners"
						v-bind="$attrs"
						:valid="valid"
						:required="required"
						class="form-control"
						:class="[
							{
								'is-valid':
									valid && validated && successMessage,
							},
							{ 'is-invalid': invalid && validated },
							inputClasses,
						]"
					>
						<option v-if="placeholder" :value="null" selected>
							{{ placeholder }}
						</option>
						<template v-if="0 < options.length">
							<option
								v-for="(option, option_idx) in options"
								:key="`option-${option.text}-${option_idx}`"
								:value="option.value"
								:selected="option.value == value"
							>
								{{ option.text }}
							</option>
						</template>
					</select>
				</slot>
				<div
					v-if="appendIcon || $slots.append"
					class="input-group-append"
				>
					<span class="input-group-text">
						<slot name="append">
							<i :class="appendIcon"></i>
						</slot>
					</span>
				</div>
				<slot name="infoBlock"></slot>
			</div>
			<slot name="success">
				<div
					class="valid-feedback"
					v-if="valid && validated && successMessage"
				>
					{{ successMessage }}
				</div>
			</slot>
			<slot name="error">
				<div
					v-if="errors[0]"
					class="invalid-feedback"
					style="display: block"
				>
					{{ errors[0] }}
				</div>
			</slot>
		</b-form-group>
	</validation-provider>
</template>
<script>
export default {
	inheritAttrs: false,
	name: "base-select",
	props: {
		required: {
			type: Boolean,
			description: "Whether input is required (adds an asterix *)",
		},
		group: {
			type: Boolean,
			description:
				"Whether input is an input group (manual override in special cases)",
		},
		alternative: {
			type: Boolean,
			description: "Whether input is of alternative layout",
		},
		label: {
			type: String,
			description: "Input label (text before input)",
		},
		placeholder: {
			type: String,
			description: "Input placeholder",
		},
		options: {
			type: Array,
			description: "Select options",
		},
		error: {
			type: String,
			description: "Input error (below select)",
		},
		successMessage: {
			type: String,
			description: "Input success message",
			default: "",
		},
		labelClasses: {
			type: String,
			description: "Input label css classes",
			default: "form-control-label",
		},
		inputClasses: {
			type: String,
			description: "Input css classes",
		},
		inputGroupClasses: {
			type: String,
			description: "Input group css classes",
		},
		value: {
			type: [String, Number],
			description: "Input value",
			default: null,
		},
		appendIcon: {
			type: String,
			description: "Append icon (right)",
		},
		prependIcon: {
			type: String,
			description: "Prepend icon (left)",
		},
		rules: {
			type: [String, Array, Object, RegExp],
			description: "Vee validate validation rules",
			default: "",
		},
		selected: {
			type: [String, Number],
			description: "Selected option",
			default: null,
		},
		name: {
			type: String,
			description: "Input name (used for validation)",
			default: "",
		},
		vid: {
			type: String,
			description: "Vee validate vid",
			default: "",
		},
	},
	data() {
		return {
			focused: false,
		};
	},
	computed: {
		listeners() {
			return {
				...this.$listeners,
				input: this.updateValue,
				focus: this.onFocus,
				blur: this.onBlur,
			};
		},
		slotData() {
			return {
				focused: this.focused,
				error: this.error,
				...this.listeners,
			};
		},
		hasIcon() {
			const { append, prepend } = this.$slots;
			return (
				append !== undefined ||
				prepend !== undefined ||
				this.appendIcon !== undefined ||
				this.prependIcon !== undefined ||
				this.group
			);
		},
	},
	methods: {
		updateValue(evt) {
			let value = evt.target.value;
			this.$emit("input", value);
		},
		onFocus(evt) {
			this.focused = true;
			this.$emit("focus", evt);
		},
		onBlur(evt) {
			this.focused = false;
			this.$emit("blur", evt);
		},
	},
};
</script>
<style></style>
